import React, { useState, useEffect, useRef, useCallback } from "react";
import "./styles.scss";
import { getAllCategory } from "../../../api/category";

// ─── SVG Icons ───────────────────────────────────────────────────────────────
const Ic = {
  Search: () => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  ),
  User: () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ),
  Heart: () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" />
    </svg>
  ),
  Cart: () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="9" cy="21" r="1" />
      <circle cx="20" cy="21" r="1" />
      <path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6" />
    </svg>
  ),
  Menu: () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  ),
  ChevronLeft: () => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="15 18 9 12 15 6" />
    </svg>
  ),
  ChevronRight: () => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="9 18 15 12 9 6" />
    </svg>
  ),
  Pause: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
      <rect x="6" y="4" width="4" height="16" />
      <rect x="14" y="4" width="4" height="16" />
    </svg>
  ),
  Play: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
      <polygon points="5 3 19 12 5 21 5 3" />
    </svg>
  ),
  ArrowRight: () => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="5" y1="12" x2="19" y2="12" />
      <polyline points="12 5 19 12 12 19" />
    </svg>
  ),

  // Category icons (simple strokes)
  Collectibles: () => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M12 8v4l3 3" />
    </svg>
  ),
  Art: () => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="13.5" cy="6.5" r="2.5" />
      <circle cx="17.5" cy="10.5" r="2.5" />
      <circle cx="8.5" cy="7.5" r="2.5" />
      <circle cx="6.5" cy="12.5" r="2.5" />
      <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" />
    </svg>
  ),
  Action: () => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 00-3-3.87" />
      <path d="M16 3.13a4 4 0 010 7.75" />
    </svg>
  ),
  Cards: () => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="5" width="20" height="14" rx="2" />
      <line x1="2" y1="10" x2="22" y2="10" />
    </svg>
  ),
  CardGames: () => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z" />
    </svg>
  ),
  Memorabilia: () => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  ),
  Toys: () => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="11" width="18" height="10" rx="2" />
      <path d="M7 11V7a5 5 0 0110 0v4" />
    </svg>
  ),
  Entertain: () => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="3" width="20" height="14" rx="2" />
      <line x1="8" y1="21" x2="16" y2="21" />
      <line x1="12" y1="17" x2="12" y2="21" />
    </svg>
  ),
  Antiques: () => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 17l9-13 9 13H3z" />
    </svg>
  ),
  Pokemon: () => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="2" y1="12" x2="22" y2="12" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  Lego: () => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="8" width="18" height="13" rx="1" />
      <rect x="7" y="4" width="4" height="4" rx="1" />
      <rect x="13" y="4" width="4" height="4" rx="1" />
    </svg>
  ),
  Funko: () => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="8" r="5" />
      <path d="M3 21s2-5 9-5 9 5 9 5" />
    </svg>
  ),
  StarWars: () => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M12 2a5 5 0 000 10 5 5 0 000-10" />
    </svg>
  ),
  Marvel: () => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  ),
  OnePiece: () => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M8 14s1.5 2 4 2 4-2 4-2" />
      <line x1="9" y1="9" x2="9.01" y2="9" />
      <line x1="15" y1="9" x2="15.01" y2="9" />
    </svg>
  ),
  HotWheels: () => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="5" cy="17" r="3" />
      <circle cx="19" cy="17" r="3" />
      <path d="M10.5 17H2v-5c0-5 3-7 7-7h3l4 4v8h-5.5" />
    </svg>
  ),
  Comics: () => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 4h16v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" />
      <path d="M8 4v4l4-2 4 2V4" />
    </svg>
  ),
  Coins: () => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="16" />
      <line x1="8.5" y1="10" x2="15.5" y2="10" />
    </svg>
  ),
  NonSport: () => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="16" y1="2" x2="16" y2="6" />
    </svg>
  ),
};

// ─── Mega menu data ──────────────────────────────────────────────────────────
const MEGA_MENU_CAT = {
  id: "col",
  label: "Collectibles & Art",
  img: "https://images.unsplash.com/photo-1612404730960-5c71577fca11?w=540&h=340&fit=crop",
  headline: "Collectibles",
  sub: "Unique items for\ntrue enthusiasts.",
};

// ─── Top nav links ───────────────────────────────────────────────────────────
const NAV_LINKS = [
  { label: "Saved" },
  { label: "Electronics" },
  { label: "Motors" },
  { label: "Fashion" },
  { label: "Collectibles & Art", hasMega: true },
  { label: "Sports" },
  { label: "Health & Beauty" },
  { label: "Industrial Equipment" },
  { label: "Home & Garden" },
  { label: "Deals" },
  { label: "Sell" },
];

// ─── Hero slides ─────────────────────────────────────────────────────────────
const SLIDES = [
  {
    id: 0,
    bg: "#F5A623",
    tag: "Summer Fashion\nFinds",
    headline: "Summer Fashion\nFinds",
    sub: "Hottest styles for the season — starting at $9.99",
    cta: "Shop Now",
    img: "https://images.unsplash.com/photo-1483985988355-763728e1935b?w=620&h=420&fit=crop",
    imgAlt: "Summer fashion items",
  },
  {
    id: 1,
    bg: "#E8F4F8",
    headline: "Top Tech Deals",
    sub: "Latest electronics at unbeatable prices",
    cta: "Explore Deals",
    img: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=620&h=420&fit=crop",
    imgAlt: "Electronics deals",
  },
  {
    id: 2,
    bg: "#F0F7EE",
    headline: "Sports Memorabilia",
    sub: "Authentic signed items from your favourite athletes",
    cta: "Browse Now",
    img: "https://images.unsplash.com/photo-1471295253337-3ceaaedca402?w=620&h=420&fit=crop",
    imgAlt: "Sports collectibles",
  },
  {
    id: 3,
    bg: "#FFF0F3",
    headline: "Rare Collectibles",
    sub: "Pokémon, LEGO, Funko & more — all in one place",
    cta: "View All",
    img: "https://images.unsplash.com/photo-1608346128025-1896b97a6fa7?w=620&h=420&fit=crop",
    imgAlt: "Rare collectibles",
  },
];

// ─── Shop by Category ────────────────────────────────────────────────────────
const SHOP_CATS = [
  {
    label: "Electronics",
    img: "https://images.unsplash.com/photo-1588702547919-26089e690ecc?w=300&h=240&fit=crop",
  },
  {
    label: "Fashion",
    img: "https://images.unsplash.com/photo-1445205170230-053b83016050?w=300&h=240&fit=crop",
  },
  {
    label: "Collectibles & Art",
    img: "https://images.unsplash.com/photo-1612404730960-5c71577fca11?w=300&h=240&fit=crop",
  },
  {
    label: "Home & Garden",
    img: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=300&h=240&fit=crop",
  },
  {
    label: "Sports",
    img: "https://images.unsplash.com/photo-1535131749006-b7f58c99034b?w=300&h=240&fit=crop",
  },
  {
    label: "Health & Beauty",
    img: "https://images.unsplash.com/photo-1571781926291-c477ebfd024b?w=300&h=240&fit=crop",
  },
  {
    label: "Industrial",
    img: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?w=300&h=240&fit=crop",
  },
  {
    label: "Motors",
    img: "https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?w=300&h=240&fit=crop",
  },
];

// ─── Helpers ─────────────────────────────────────────────────────────────────
const getIcon = (name) => {
  const C = Ic[name];
  return C ? <C /> : null;
};

const isSameId = (a, b) => a != null && b != null && String(a) === String(b);

const CATEGORY_FALLBACK_IMG =
  "https://images.unsplash.com/photo-1612404730960-5c71577fca11?w=540&h=340&fit=crop";

// ─── Mega Menu Panel ─────────────────────────────────────────────────────────
const MegaMenuItem = ({
  category,
  subcategory,
  activeCatId,
  onSelectCategory,
}) => {
  const id = getCategoryId(category);
  const name = category
    ? getCategoryName(category)
    : getSubCategoryName(subcategory);
  const img = getCategoryImage(category, null);
  //   const subName = getSubCategoryName(subcategory);

  return (
    <li>
      <button
        className={`ohp-mega__item ${isSameId(activeCatId, id) ? "ohp-mega__item--highlight" : ""}`}
        onClick={() => onSelectCategory?.(category)}
      >
        <span className="ohp-mega__item-icon">
          {img ? (
            <img
              src={img}
              alt={name}
              onError={(e) => (e.target.style.display = "none")}
            />
          ) : (
            getIcon("Collectibles")
          )}
        </span>
        <span>{name}</span>
      </button>
    </li>
  );
};

const MegaMenu = ({
  categories = [],
  subcategories = [],
  loading = false,
  activeCatId = null,
  onSelectCategory,
  onClose,
}) => {
  const mid = Math.ceil(categories.length / 2);
  const popular = categories.slice(0, mid);
  const more = subcategories.length > 0 ? subcategories : categories.slice(mid);
  const promoCategory =
    categories.find((c) => isSameId(getCategoryId(c), activeCatId)) ??
    categories[0];

  return (
    <div className="ohp-mega" onMouseLeave={onClose}>
      <div className="ohp-mega__inner">
        {/* Popular categories */}
        <div className="ohp-mega__col">
          <p className="ohp-mega__col-title">Most popular categories</p>
          {loading && (
            <p className="ohp-mega__col-title">Loading categories…</p>
          )}
          {!loading && categories.length === 0 && (
            <p className="ohp-mega__col-title">No categories found.</p>
          )}
          <ul className="ohp-mega__list">
            {popular.map((c) => (
              <MegaMenuItem
                key={getCategoryId(c) ?? getCategoryName(c)}
                category={c}
                subcategory={null}
                activeCatId={activeCatId}
                onSelectCategory={onSelectCategory}
              />
            ))}
          </ul>
        </div>

        {/* Divider */}
        <div className="ohp-mega__divider" />

        {/* More categories */}
        <div className="ohp-mega__col">
          <p className="ohp-mega__col-title">Sub categories</p>
          <ul className="ohp-mega__list">
            {subcategories.map((c) => (
              <MegaMenuItem
                key={getCategoryId(c) ?? getCategoryName(c)}
                category={null}
                subcategory={c}
                activeCatId={activeCatId}
                onSelectCategory={onSelectCategory}
              />
            ))}
          </ul>
        </div>

        {/* Promo panel */}
        <div className="ohp-mega__promo">
          <div className="ohp-mega__promo-card">
            <img
              src={getCategoryImage(promoCategory, MEGA_MENU_CAT.img)}
              alt={
                promoCategory ? getCategoryName(promoCategory) : "Collectibles"
              }
              className="ohp-mega__promo-img"
              onError={(e) => (e.target.style.opacity = 0)}
            />
            <div className="ohp-mega__promo-content">
              <h3 className="ohp-mega__promo-headline">
                {promoCategory
                  ? getCategoryName(promoCategory)
                  : MEGA_MENU_CAT.headline}
              </h3>
              <p className="ohp-mega__promo-sub">{MEGA_MENU_CAT.sub}</p>
              <button className="ohp-mega__promo-cta">Explore now</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// ─── Hero Slider ─────────────────────────────────────────────────────────────
const HeroSlider = () => {
  const [current, setCurrent] = useState(0);
  const [paused, setPaused] = useState(false);
  const timerRef = useRef(null);

  const advance = useCallback((dir = 1) => {
    setCurrent((prev) => (prev + dir + SLIDES.length) % SLIDES.length);
  }, []);

  useEffect(() => {
    if (paused) return;
    timerRef.current = setInterval(() => advance(1), 4800);
    return () => clearInterval(timerRef.current);
  }, [paused, advance]);

  const slide = SLIDES[current];

  return (
    <div className="ohp-hero" style={{ background: slide.bg }}>
      <div className="ohp-hero__content">
        <p className="ohp-hero__eyebrow">Limited Time Offer</p>
        <h2 className="ohp-hero__headline">{slide.headline}</h2>
        <p className="ohp-hero__sub">{slide.sub}</p>
        <button className="ohp-hero__cta">{slide.cta}</button>
        <p className="ohp-hero__terms">*See terms.</p>
      </div>
      <div className="ohp-hero__img-wrap">
        <img
          src={slide.img}
          alt={slide.imgAlt}
          className="ohp-hero__img"
          key={slide.id}
          onError={(e) => (e.target.style.opacity = 0)}
        />
      </div>

      {/* Controls */}
      <div className="ohp-hero__controls">
        <button
          className="ohp-hero__ctrl-btn"
          onClick={() => advance(-1)}
          aria-label="Previous slide"
        >
          <Ic.ChevronLeft />
        </button>
        <button
          className="ohp-hero__ctrl-btn"
          onClick={() => advance(1)}
          aria-label="Next slide"
        >
          <Ic.ChevronRight />
        </button>
        <button
          className="ohp-hero__ctrl-btn ohp-hero__ctrl-btn--pause"
          onClick={() => setPaused((p) => !p)}
          aria-label={paused ? "Play" : "Pause"}
        >
          {paused ? <Ic.Play /> : <Ic.Pause />}
        </button>
      </div>

      {/* Dots */}
      <div className="ohp-hero__dots">
        {SLIDES.map((s, i) => (
          <button
            key={s.id}
            className={`ohp-hero__dot ${i === current ? "ohp-hero__dot--active" : ""}`}
            onClick={() => setCurrent(i)}
            aria-label={`Go to slide ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

// ─── Category Grid ────────────────────────────────────────────────────────────
const CategoryGrid = ({
  categories = [],
  loading = false,
  activeCatId = null,
  onSelectCategory,
}) => (
  <section className="ohp-cats">
    <div className="ohp-cats__header">
      <h2 className="ohp-cats__title">Shop by Category</h2>
      <button className="ohp-cats__view-all">
        View All <Ic.ArrowRight />
      </button>
    </div>
    <div className="ohp-cats__grid">
      {loading && (
        <div className="ohp-cat-card__label">Loading categories…</div>
      )}
      {!loading &&
        categories.map((c, i) => {
          const id = getCategoryId(c);
          const name = getCategoryName(c);
          const img = getCategoryImage(
            c,
            SHOP_CATS[i % SHOP_CATS.length]?.img ?? CATEGORY_FALLBACK_IMG,
          );

          return (
            <button
              key={id ?? name}
              className={`ohp-cat-card ${isSameId(activeCatId, id) ? "ohp-cat-card--active" : ""}`}
              onClick={() => onSelectCategory?.(c)}
            >
              <div className="ohp-cat-card__img-wrap">
                <img
                  src={img}
                  alt={name}
                  className="ohp-cat-card__img"
                  onError={(e) => (e.target.style.opacity = 0)}
                />
              </div>
              <span className="ohp-cat-card__label">{name}</span>
            </button>
          );
        })}
      {!loading && categories.length === 0 && (
        <div className="ohp-cat-card__label">No categories found.</div>
      )}
    </div>
  </section>
);

const getCategoryId = (category) =>
  category?.category_id ?? category?.id ?? category?._id;

const getCategoryName = (category) =>
  category?.category_name ?? category?.name ?? "";

const getCategoryImage = (category, fallback) =>
  category?.image_url ??
  category?.image ??
  category?.thumbnail ??
  category?.category_image ??
  fallback;

const getSubCategoryId = (subCategory) =>
  subCategory?.sub_category_id ??
  subCategory?.subcategory_id ??
  subCategory?.id;

const getSubCategoryName = (subCategory) =>
  subCategory?.sub_category_name ??
  subCategory?.subcategory_name ??
  subCategory?.name ??
  "";

const getSubCategoryImage = (subCategory, fallback) =>
  subCategory?.image_url ??
  subCategory?.image ??
  subCategory?.thumbnail ??
  subCategory?.sub_category_image ??
  fallback;

const getSubCategories = (category) =>
  Array.isArray(category?.sub_category)
    ? category.sub_category
    : Array.isArray(category?.sub_categories)
      ? category.sub_categories
      : [];

// ─── Main Component ───────────────────────────────────────────────────────────
export default function OmeHomepage() {
  const [megaOpen, setMegaOpen] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [activeNav, setActiveNav] = useState("Collectibles & Art");
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [activeCatId, setActiveCatId] = useState(null);
  const [activeSubCatId, setActiveSubCatId] = useState(null);
  const [loadingCategories, setLoadingCategories] = useState(true);

  const handleCategorySelect = (category) => {
    const nextCategoryId = getCategoryId(category);
    setActiveCatId(nextCategoryId);
    setActiveSubCatId(null);
    setSubCategories(getSubCategories(category));
    // setSelectedBrands([]);
    // setSearchTerm("");
    // setPage(1);
  };

  const getAllCategories = async () => {
    try {
      const response = await getAllCategory();
      const dbCategories = response?.data?.categories || [];
      if (response?.data?.status && dbCategories.length > 0) {
        const firstCategory = dbCategories[0];
        setCategories(dbCategories);
        handleCategorySelect(firstCategory);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoadingCategories(false);
    }
  };

  useEffect(() => {
    getAllCategories();
    // getAllProducts();
  }, []);

  return (
    <div className="ohp-root">
      {/* ── HEADER ─────────────────────────────────────────────────────────── */}
      <header className="ohp-header">
        {/* ── Secondary nav ───────────────────────────────────────────────── */}
        <nav className="ohp-nav" aria-label="Main categories">
          <div className="ohp-nav__inner">
            <button className="ohp-nav__all-cats">
              <Ic.Menu />
              <span>All Categories</span>
            </button>
            <div className="ohp-nav__links">
              {categories.map((c, i) => {
                const id = getCategoryId(c);
                const name = getCategoryName(c);
                console.log("Rendering nav link for category:", c);

                return (
                  <button
                    key={name}
                    className={`ohp-nav__link ${activeNav === name ? "ohp-nav__link--active" : ""}`}
                    onClick={() => {
                      setActiveNav(name);
                      if (c.sub_category && c.sub_category.length > 0) {
                        setMegaOpen((v) => !v);
                        setSubCategories(getSubCategories(c));
                      } else {
                        setMegaOpen(false);
                        setSubCategories([]);
                      }
                    }}
                    // onMouseEnter={() =>
                    //   c.sub_category && c.sub_category.length > 0
                    //     ? setMegaOpen(true)
                    //     : setMegaOpen(false)
                    // }
                    // onMouseHover={() =>
                    //   c.sub_category && c.sub_category.length > 0
                    //     ? setMegaOpen(true)
                    //     : setMegaOpen(false)
                    // }
                  >
                    <span>{name}</span>
                  </button>
                );
              })}
            </div>
          </div>
        </nav>

        {/* ── Mega menu ───────────────────────────────────────────────────── */}
        {megaOpen && (
          <MegaMenu
            categories={categories}
            subcategories={subCategories}
            loading={loadingCategories}
            activeCatId={activeCatId}
            onSelectCategory={handleCategorySelect}
            onClose={() => setMegaOpen(false)}
          />
        )}

        {/* ── Mobile menu ─────────────────────────────────────────────────── */}
        {mobileMenu && (
          <div className="ohp-mobile-menu">
            {NAV_LINKS.map((l) => (
              <button
                key={l.label}
                className="ohp-mobile-menu__item"
                onClick={() => setMobileMenu(false)}
              >
                {l.label}
              </button>
            ))}
          </div>
        )}
      </header>

      {/* ── HERO ───────────────────────────────────────────────────────────── */}
      <main>
        <HeroSlider />

        {/* ── SHOP BY CATEGORY ──────────────────────────────────────────── */}
        <CategoryGrid
          categories={categories}
          loading={loadingCategories}
          activeCatId={activeCatId}
          onSelectCategory={handleCategorySelect}
        />
      </main>
    </div>
  );
}
